import { Button, MenuItem, SelectChangeEvent } from "@mui/material";
import { Select } from "@mui/material";
import { Grid, Paper } from "@mui/material";
import { CustomDisclaimerDialogPropsType } from "../../../../../../../types/dialogProps.types";
import CustomEnrollmentDisclaimerDialog from "../../../../../../shared/dialogs/customEnrollmentDisclaimerDialog/customEnrollmentDisclaimerDialog";
import { useContext, useEffect, useMemo, Suspense, useRef } from "react";
import { VEBToGeneralCoverageCodeType, VEB_TO_GENERAL_COVERAGE_CODE } from "../../../../../../../constants/coverage";
import {
	AuthContext,
	EligibleDependentContext,
	EnrollmentContext,
	GroupOwnerContext,
	PaycheckContext,
	ThemeContext
} from "../../../../../../../contexts";
import { LazyCustomFormDialog, LazyPlanActions, VEBDisclaimer } from "../../../../../../shared";
import { Checkbox } from "@mui/material";
import { useState } from "react";
import { useCallback } from "react";

import "./hospitalIndemnityForm.css";
import {
	HospitalIndemnityPlanCoverage,
	HospitalIndemnityPlanCoverageLevel,
	HospitalIndemnityPlanCoverageType,
	HospitalIndemnityPlanDetails,
	VEBPlan
} from "../../../../../../../types/plan.types";
import initCapitalize from "../../../../../../../utils/commonFunctions/initCapitalize";
import { getKemperHospitalEligibleDependents } from "../../../../../../../utils/commonFunctions/VEBEnrollment/eligibleDependents";
import { dollarize } from "../../../../../../../utils/commonFunctions/dollarize";
import { CustomInput, CustomSelectInput } from "../../../../../../shared/CustomInput";
import { Member } from "../../../../../../../types/employee.types";
import { VEBPlanFormProps } from "../../../../../../../types/components/enrollmentProps.types";
import VEBPlanHeader from "../../../../../../shared/enrollment/VEBPlanHeader/PlanHeader";
import { dateTimeZoneConverter, getFirstOfNextMonth } from "../../../../../../../utils/commonFunctions/date";
import {
	generateActivateVEBEnrollmentPayload,
	generateHospitalKemperWaiveEnrollmentPayload
} from "../../../../../../../utils/commonFunctions/VEBEnrollment/enrollment";
import { VEBEnrollmentPayload } from "../../../../../../../utils/api/enrollment/enrollment";
import { api } from "../../../../../../../utils/api";
import { useHistory, useLocation } from "react-router-dom";
import { CustomFormDialogType } from "../../../../../../../types/components/dialogProps.types";
import { VEB_PLAN_NAME, VEB_PLAN_NAMES } from "../../../../../../../constants/plan";
import { trackPromise } from "react-promise-tracker";
import { EligiblityDialogProps } from "../../../../../../../types/components/eligiblityDialogProps.types";
import EligiblityDialog from "../../../../eligiblityDialogs/EligiblityDialog";
import { VEBPlanCodes2024 } from "../../../../../../../constants/VEBPlanCodes/VEBPlanCodes2024";
import { VEBYearlyOpenAndCurrentEffectiveDate } from "../../../../../../../constants/VEBYearlyOpenAndCurrentDate";
import ExistsDependentModelVEB from "../../../../../../shared/existsMemberModel/ExistsDependentModelVEB";

const KemperHospitalIndemnityForm = ({
	VEBOpenEnrollment,
	dependents,
	getVEBEnrollmentInitData
}: VEBPlanFormProps): JSX.Element => {
	const [waiveReason, setWaiveReason] = useState("");
	const { groupOwner } = useContext(GroupOwnerContext);
	const [hasReadTC, setHasReadTC] = useState(false);
	const [isActivelyWorking, setIsActivelyWorking] = useState(false);
	const [emailDisclaimer, setEmailDisclaimer] = useState("");
	const [isDependentExistsModelOpen, setIsDependentExistsModelOpen] = useState(false);
	const [existsDependentData, setExistsDependentData] = useState<any>(null);
	const isDependentExistsModelOpenRef = useRef(false);
	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();
	const [writingNumber, setWritingNumber] = useState(1408);
	const [enrollmentDisclaimerDialogProps, setEnrollmentDisclaimerDialogProps] =
		useState<CustomDisclaimerDialogPropsType>({
			openDialog: false,
			title: "Disclaimer",
			content:
				"Hospital Indemnity: The information in this Enrollment Form is true and complete as of the date I signed this Enrollment Form. I elect to participate in the plan indicated above. I hereby represent that I have reviewed the fraud warning notice. FRAUD WARNING: Any person who with intent to defraud or knowing that he or she is facilitating a fraud against an insurer, submits an application or files a claim containing a false or deceptive statement may be guilty of insurance fraud.",
			importantTitle: "IMPORTANT",
			importantContent:
				"If an individual is insured under this policy and is also covered by Medicaid or a state variation of Medicaid, most non-disability benefits are automatically assigned according to state regulations.  This means that instead of paying the benefits to the insured individual, we must pay the benefits to Medicaid or the medical provider to reduce the charges billed to Medicaid.  Please consider your circumstances before enrolling in Kemper Benefits coverage.",
			inputFields: [
				{
					name: "Email Discalimer",
					value: emailDisclaimer,
					placeholder: "Enter Email"
				}
			],
			actions: [
				{
					label: "Email Disclaimer",
					callback: () => {
						null;
						// setEnrollmentDisclaimerDialogProps(
						// 	Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false })
						// );
					}
				}
			]
		});
	const [planCode, setPlanCode] = useState<string>();
	const [VEBOpenEnrollmentId, setVEBOpenEnrollmentId] = useState<string>();
	const [hospitalIndemnityPlan, setHospitalIndemnityPlan] = useState<VEBPlan>({
		_id: "",
		plan_name: "",
		plan_code: "",
		start_date: null,
		end_date: null,
		status: ""
	});
	const [hospitalIndemnityPlanDetails, setHospitalIndemnityPlanDetails] = useState<HospitalIndemnityPlanDetails>({
		coverage: [],
		coverage_level: ["Plan 1", "Plan 2", "Plan 3", "Plan 4"],
		coverage_type: ["Monthly", "Weekly"],
		premium_amount: {
			standard_premium: {
				"Employee Only": {
					"Plan 1": {
						MONTHLY: 4.54,
						WEEKLY: 1.05
					},
					"Plan 2": {
						MONTHLY: 6.8,
						WEEKLY: 1.57
					},
					"Plan 3": {
						MONTHLY: 9.07,
						WEEKLY: 2.09
					},
					"Plan 4": {
						MONTHLY: 13.61,
						WEEKLY: 3.14
					}
				},
				"Employee & Children": {
					"Plan 1": {
						MONTHLY: 8.53,
						WEEKLY: 1.97
					},
					"Plan 2": {
						MONTHLY: 12.79,
						WEEKLY: 2.95
					},
					"Plan 3": {
						MONTHLY: 17.05,
						WEEKLY: 3.94
					},
					"Plan 4": {
						MONTHLY: 25.58,
						WEEKLY: 5.9
					}
				},
				"Employee & Spouse": {
					"Plan 1": {
						MONTHLY: 9.07,
						WEEKLY: 2.09
					},
					"Plan 2": {
						MONTHLY: 13.61,
						WEEKLY: 3.14
					},
					"Plan 3": {
						MONTHLY: 18.14,
						WEEKLY: 4.19
					},
					"Plan 4": {
						MONTHLY: 27.22,
						WEEKLY: 6.28
					}
				},
				"Employee & Family": {
					"Plan 1": {
						MONTHLY: 13.06,
						WEEKLY: 3.01
					},
					"Plan 2": {
						MONTHLY: 19.6,
						WEEKLY: 4.52
					},
					"Plan 3": {
						MONTHLY: 26.13,
						WEEKLY: 6.03
					},
					"Plan 4": {
						MONTHLY: 39.19,
						WEEKLY: 9.04
					}
				}
			}
		}
	});
	const [prevWritingNumber, setPrevWritingNumber] = useState(1408);
	const [showWritingNumberValidateButton, setShowWritingNumberValidateButton] = useState(false);
	const { theme } = useContext(ThemeContext);
	const { eligiblity, setEligiblity } = useContext(EligibleDependentContext);
	const [eligibleDependents, setEligibleDependents] = useState<Member[]>([]);
	const [hospitalIndemnityPlanInputs, setHospitalIndemnityPlanInputs] = useState<{
		coverage: null | string;
		coverage_level: null | string;
	}>({
		coverage: null,
		coverage_level: null
	});
	const [eligiblityDialogProps, setEligiblityDialogProps] = useState<any>({
		openDialog: false,
		handleCloseEligiblityDialog: () =>
			setEligiblityDialogProps(
				Object.assign({}, eligiblityDialogProps, {
					openDialog: false
				})
			),
		eligibleDependents: [],
		ineligibleDependents: [],
		ineligibleRelationshipDependents: [],
		VEBPlanName: "Hospital Indemnity"
	});
	const [standardPremium, setStandardPremium] = useState(0);
	const history = useHistory();
	const location = useLocation();
	const { member } = useContext(AuthContext);
	const { paycheck } = useContext(PaycheckContext);
	const { setCurrentEnrollment, deleteCurrentEnrollment } = useContext(EnrollmentContext);

	const getVEBPlanCode = useCallback((VEBOpenEnrollment: any[]) => {
		// // console.log("**********VEBOpenEnrollment********", VEBOpenEnrollment[0]);
		let _planCode, _VEBOpenEnrollmentId;
		for (let idx = 0; idx < VEBOpenEnrollment.length; idx++) {
			const planName = VEBOpenEnrollment[idx].open_enrollment.veb_plan_name;
			const planCode = VEBOpenEnrollment[idx].open_enrollment.veb_plan_code;
			const VEBPlanId = VEBOpenEnrollment[idx].open_enrollment.veb_plan_id;
			const VEBOpenEnrollmentId = VEBOpenEnrollment[idx].VEB_open_enrollment_id;
			// // console.log("<====Plan Name===>", planName);

			if (planName === VEB_PLAN_NAMES.hospital_indemnity) {
				_planCode = planCode;
				_VEBOpenEnrollmentId = VEBOpenEnrollmentId;

				const _planPaylaod = {
					_id: VEBPlanId,
					plan_name: planName,
					plan_code: _planCode,
					start_date: null,
					end_date: null,
					status: "ACTIVE"
				};

				setHospitalIndemnityPlan(Object.assign({}, _planPaylaod));
			}
		}

		setPlanCode(_planCode);
		setVEBOpenEnrollmentId(_VEBOpenEnrollmentId);
	}, []);

	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

	const handleWaiveReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setWaiveReason(value);
	};

	const handleWaiveEnrollment = useCallback(async () => {
		if (member === null || VEBOpenEnrollment === null) {
			return;
		}
		const { VEBEnrollmentCommonDetails, VEBEnrollmentStandardDetails } =
			generateHospitalKemperWaiveEnrollmentPayload(
				hospitalIndemnityPlan,
				VEB_PLAN_NAME.kemper.hospital.standard_hospital,
				VEB_PLAN_NAME.kemper.hospital.standard_hospital,
				null,
				groupOwner,
				member,
				waiveReason,
				VEBOpenEnrollmentId as unknown as string,
				false
			);
		const VEBEnrollmentPayload: VEBEnrollmentPayload = {
			standard_details: VEBEnrollmentStandardDetails,
			common_details: VEBEnrollmentCommonDetails,
			isRider: false
		};
		const response = await trackPromise(api.enrollment.addVEBEnrollment(VEBEnrollmentPayload));
		// console.log("response", response);
		deleteCurrentEnrollment();
		getVEBEnrollmentInitData();
		const step = urlSearchParams.get("step");
		history.push(`?step=${step}&stage=2`);
	}, [
		member,
		VEBOpenEnrollment,
		hospitalIndemnityPlan,
		groupOwner,
		waiveReason,
		VEBOpenEnrollmentId,
		deleteCurrentEnrollment,
		getVEBEnrollmentInitData,
		urlSearchParams,
		history
	]);

	const handleCoverageChange = useCallback(
		(event: SelectChangeEvent<unknown>, child: React.ReactNode) => {
			const { name, value } = event.target;
			setHospitalIndemnityPlanInputs(
				Object.assign({}, hospitalIndemnityPlanInputs, {
					[name]: value
				})
			);
		},
		[hospitalIndemnityPlanInputs]
	);

	const handleAgreedTCCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setHasReadTC(checked);
	};

	const handleIsActivelyWorkingCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setIsActivelyWorking(checked);
	};

	const handleOpenDisclaimerDialogClick = useCallback(() => {
		setEnrollmentDisclaimerDialogProps(Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: true }));
	}, [enrollmentDisclaimerDialogProps]);

	const handleWaiveButtonClick = useCallback(() => {
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Are you sure want to waive this enrollment?",
				textfields: [
					{
						label: "Waive Reason",
						onChange: handleWaiveReasonChange,
						value: waiveReason,
						placeholder: "Enter your reason for waive"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () =>
							setCustomFormDialogProps(Object.assign({}, customFormDialogProps, { openDialog: false }))
					},
					{
						label: "Yes",
						callback: () => {
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							);
							handleWaiveEnrollment();
						}
					}
				]
			})
		);
	}, [customFormDialogProps, handleWaiveEnrollment, waiveReason]);

	const handleCloseDisclaimerDialog = useCallback(() => {
		setEnrollmentDisclaimerDialogProps(Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false }));
	}, [enrollmentDisclaimerDialogProps]);

	const handleEscapeCloseDisclaimerDialog = useCallback(
		(event: React.KeyboardEvent<HTMLInputElement | HTMLDivElement>) => {
			const Key = event.key;

			if (Key === "Escape")
				setEnrollmentDisclaimerDialogProps(
					Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false })
				);
		},
		[enrollmentDisclaimerDialogProps]
	);

	const handleWritingNumberChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { value } = event.target as HTMLInputElement;
			setWritingNumber(Number(value));
			if (Number(value) !== prevWritingNumber) {
				setShowWritingNumberValidateButton(true);
			} else {
				setShowWritingNumberValidateButton(false);
			}
		},
		[prevWritingNumber]
	);

	const handleValidation = useCallback((): boolean => {
		const { coverage, coverage_level } = hospitalIndemnityPlanInputs;
		if (coverage === null || coverage_level === null) {
			alert("Please fill all required fields");
			return false;
		}
		if (hasReadTC === false) {
			alert("Please agree to the Disclaimer");
			return false;
		}
		if (isActivelyWorking === false) {
			alert("You must actively working 20 hours or more to enroll");
			return false;
		}
		return true;
	}, [hasReadTC, hospitalIndemnityPlanInputs, isActivelyWorking]);

	const waitForModalToClose = () =>
		//eslint-disable-next-line
		new Promise<void>((resolve) => {
			const checkModal = () => {
				if (!isDependentExistsModelOpenRef.current) {
					resolve();
				} else {
					setTimeout(checkModal, 1000);
				}
			};
			checkModal();
		});

	const handleActivateButtonCallback = useCallback(async () => {
		const isValid = handleValidation();
		if (isValid === false) {
			return;
		}
		if (
			member &&
			hospitalIndemnityPlanInputs.coverage &&
			hospitalIndemnityPlanInputs.coverage_level &&
			paycheck &&
			VEBOpenEnrollment
		) {
			// console.log("hospitalrPlanInputs", hospitalIndemnityPlanInputs);
			const { VEBEnrollmentCommonDetails, VEBEnrollmentStandardDetails } = generateActivateVEBEnrollmentPayload(
				hospitalIndemnityPlan,
				groupOwner,
				member,
				0,
				VEB_TO_GENERAL_COVERAGE_CODE[
					hospitalIndemnityPlanInputs.coverage as keyof VEBToGeneralCoverageCodeType
				],
				standardPremium,
				eligibleDependents,
				VEB_PLAN_NAME.kemper.hospital.standard_hospital,
				standardPremium,
				VEB_PLAN_NAME.kemper.hospital.standard_hospital,
				hospitalIndemnityPlanInputs.coverage_level,
				VEBOpenEnrollmentId as unknown as string,
				paycheck,
				writingNumber
			);
			const VEBEnrollmentPayload: VEBEnrollmentPayload = {
				standard_details: VEBEnrollmentStandardDetails,
				common_details: VEBEnrollmentCommonDetails,
				isRider: false
			};
			const existEnrollmentData = await trackPromise(api.enrollment.existsVEBEnrollment(VEBEnrollmentPayload));
			if (Array.isArray(existEnrollmentData) && existEnrollmentData.length > 0) {
				setIsDependentExistsModelOpen(true);
				// setExistsDependentData(existEnrollmentData[0].member);
				//eslint-disable-next-line
				setExistsDependentData(existEnrollmentData.map((item) => item.member));
				isDependentExistsModelOpenRef.current = true;
				await waitForModalToClose();
			} else {
				setExistsDependentData(null); // Handle empty case
			}
			if (existEnrollmentData && Array.isArray(existEnrollmentData) && existEnrollmentData.length > 0) {
				const existingSSNs = existEnrollmentData
					//eslint-disable-next-line
					.map((enrollment) => enrollment?.member?.SSN)
					//eslint-disable-next-line
					.filter((ssn) => ssn); // Filter out undefined or null SSNs

				if (existingSSNs.length > 0 && VEBEnrollmentPayload.standard_details) {
					VEBEnrollmentPayload.standard_details = VEBEnrollmentPayload.standard_details.filter(
						(detail: any) => !existingSSNs.includes(detail.member_SSN) && !detail.member_SSN.includes("@")
					);
				}
			}
			if (VEBEnrollmentPayload.standard_details && VEBEnrollmentPayload.standard_details.length === 1) {
				const selectedCoverageLevel =
					hospitalIndemnityPlanInputs.coverage_level as keyof HospitalIndemnityPlanCoverageLevel;
				const coverageLevel = hospitalIndemnityPlanDetails.coverage_level.includes(selectedCoverageLevel)
					? selectedCoverageLevel
					: hospitalIndemnityPlanDetails.coverage_level[0];
				const frequency = paycheck.pay_frequency === "MONTHLY" ? "MONTHLY" : "WEEKLY";

				const employeeOnlyPremium =
					hospitalIndemnityPlanDetails.premium_amount.standard_premium["Employee Only"][coverageLevel][
						frequency
					];
				console.log("CHECKINGTHISSHIT", employeeOnlyPremium);

				const totalPremium = employeeOnlyPremium;

				VEBEnrollmentPayload.standard_details[0].premium_amount = totalPremium;
			}
			const response = await api.enrollment.addVEBEnrollment(VEBEnrollmentPayload);
			getVEBEnrollmentInitData();
			deleteCurrentEnrollment();
			const step = urlSearchParams.get("step");
			history.push(`?step=${step}&stage=2`);
		}
	}, [
		handleValidation,
		member,
		hospitalIndemnityPlanInputs,
		paycheck,
		VEBOpenEnrollment,
		hospitalIndemnityPlan,
		groupOwner,
		standardPremium,
		eligibleDependents,
		VEBOpenEnrollmentId,
		writingNumber,
		getVEBEnrollmentInitData,
		deleteCurrentEnrollment,
		urlSearchParams,
		history
	]);
	useEffect(() => {
		isDependentExistsModelOpenRef.current = isDependentExistsModelOpen;
	}, [isDependentExistsModelOpen]);
	const calculatePremium = useCallback(() => {
		const { coverage, coverage_level } = hospitalIndemnityPlanInputs;
		if (coverage && coverage_level && paycheck) {
			const newStandardPremium =
				hospitalIndemnityPlanDetails.premium_amount.standard_premium[
					coverage as keyof HospitalIndemnityPlanCoverage
				][coverage_level as keyof HospitalIndemnityPlanCoverageLevel][
					paycheck.pay_frequency as keyof HospitalIndemnityPlanCoverageType
				];
			setStandardPremium(newStandardPremium);
			setCurrentEnrollment(
				Object.assign(
					{},
					{
						plan_name: "Hospital Indemnity",
						status: "Current",
						premium_amount: Number(newStandardPremium.toFixed(2))
					}
				)
			);
		}
	}, [
		hospitalIndemnityPlanDetails.premium_amount.standard_premium,
		hospitalIndemnityPlanInputs,
		paycheck,
		setCurrentEnrollment
	]);

	useEffect(() => {
		if (VEBOpenEnrollment && VEBOpenEnrollment.length !== 0) {
			getVEBPlanCode(VEBOpenEnrollment);
		}
	}, [VEBOpenEnrollment, getVEBPlanCode]);

	useEffect(() => {
		calculatePremium();
	}, [calculatePremium, hospitalIndemnityPlanInputs.coverage, hospitalIndemnityPlanDetails.coverage_level]);

	useEffect(() => {
		const dependentCoverage = getKemperHospitalEligibleDependents(dependents);
		setEligibleDependents(Object.assign([], dependentCoverage.dependents));
		setHospitalIndemnityPlanDetails((prevHospitalIndemnityPlanDetails: HospitalIndemnityPlanDetails) => {
			return Object.assign({}, prevHospitalIndemnityPlanDetails, {
				coverage: dependentCoverage.coverage
			});
		});
		setEligiblityDialogProps((prevEligiblityDialogProps: EligiblityDialogProps) => {
			return Object.assign({}, prevEligiblityDialogProps, {
				openDialog: true,
				eligibleDependents: Object.assign([], dependentCoverage.dependents),
				ineligibleRelationshipDependents: Object.assign([], dependentCoverage.ineligibleRelationshipDependents),
				ineligibleDependents: Object.assign([], dependentCoverage.ineligibleDependents)
			});
		});
		setEligiblity(
			Object.assign(
				{},
				{
					eligibleDependents: Object.assign([], dependentCoverage.dependents),
					ineligibleRelationshipDependents: Object.assign(
						[],
						dependentCoverage.ineligibleRelationshipDependents
					),
					ineligibleDependents: Object.assign([], dependentCoverage.ineligibleDependents)
				}
			)
		);
	}, [dependents, setEligiblity]);

	return (
		<>
			<div className="kemper-cancer-form plan-form">
				<Suspense fallback={<div />}>
					<EligiblityDialog eligiblityDialogProps={eligiblityDialogProps} />
				</Suspense>
				<CustomEnrollmentDisclaimerDialog
					enrollmentDisclaimerDialogProps={enrollmentDisclaimerDialogProps}
					handleCloseDisclaimerDialog={handleCloseDisclaimerDialog}
					handleEscapeCloseDisclaimerDialog={handleEscapeCloseDisclaimerDialog}
					emailDisclaimer={emailDisclaimer}
					setEmailDisclaimer={setEmailDisclaimer}
				/>
				<Suspense fallback={<div />}>
					{customFormDialogProps ? (
						<LazyCustomFormDialog customFormDialogProps={customFormDialogProps} />
					) : null}
				</Suspense>
				<div className="paper-form-container">
					<Paper className="theme-border-radius paper-container" elevation={1}>
						<VEBPlanHeader
							planName="MedMutual Protect Group Hospital Indemnity Insurance Policy"
							effectiveDate={
								planCode
									? planCode === "HI-ALL-2024"
										? VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_MMDDYYYY
										: VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_MMDDYYYY
									: "N/A"
							}
							planCode={planCode ? (planCode as unknown as string) : "No Plan is Opened"}
						/>
						<div className="plan-content">
							<div className="theme-plan-section-margin" />
							<div className="header-container">
								<div className="header-container header-container-new">
									<div className="theme-plan-header">Standard Benefits</div>
								</div>
								<div
									className="theme-plan-sub-header plan-text"
									style={{ borderLeftColor: theme.primary_color }}
								>
									In addition to yourself, who would you like to cover under this plan?
								</div>
							</div>
							<div className="theme-plan-inner-section-margin-2" />
							<Grid className="grid-container" container columnSpacing={2}>
								<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
									<div className="details-form-row">
										<div className="details-form-label  required">Coverage For</div>
										<Select
											input={<CustomSelectInput />}
											style={{ width: "100%" }}
											name="coverage"
											onChange={handleCoverageChange}
										>
											{hospitalIndemnityPlanDetails.coverage.map(
												(option: string, index: number) => {
													return (
														<MenuItem value={option} key={index}>
															{initCapitalize(option)}
														</MenuItem>
													);
												}
											)}
										</Select>
									</div>
								</Grid>
								<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
									<div className="details-form-row">
										<div className="details-form-label  required">Coverage Level</div>
										<Select
											input={<CustomSelectInput />}
											style={{ width: "100%" }}
											name="coverage_level"
											onChange={handleCoverageChange}
										>
											<MenuItem value={"Plan 1"}>PLAN 1</MenuItem>
											<MenuItem value={"Plan 2"}>PLAN 2</MenuItem>
											<MenuItem value={"Plan 3"}>PLAN 3</MenuItem>
											<MenuItem value={"Plan 4"}>PLAN 4</MenuItem>
										</Select>
									</div>
								</Grid>
								<Grid item xl={2} lg={2} md={2} sm={2} xs={6}>
									<div className="details-form-row">
										<div className="details-form-label required align-center">Premium</div>
										<div className="show-premium">{dollarize(standardPremium)}</div>
									</div>
								</Grid>
							</Grid>
						</div>
						<div className="theme-plan-inner-section-margin" />
						<Grid container className="theme-plan-inner-section-margin">
							<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
								<div className="details-form-row">
									<div
										className="details-form-label theme-plan-total-premium align-right"
										style={{ color: theme.primary_color }}
									>
										Total Premium:{" "}
										<span className="show-premium margin-adjust">{dollarize(standardPremium)}</span>
									</div>
								</div>
							</Grid>
						</Grid>
						{!VEBPlanCodes2024.includes(planCode as unknown as string) ? (
							<div className="veb-disclaimer">{/* <VEBDisclaimer /> */}</div>
						) : null}
						<div className="theme-plan-option-content">
							<Checkbox
								checked={isActivelyWorking}
								onChange={handleIsActivelyWorkingCheckboxChange}
								style={{ paddingLeft: 0 }}
							/>
							<p className="theme-plan-checkbox-label">
								<strong>Are you actively at work 20 or more hours per week?</strong>
							</p>
						</div>
						<div>
							<div className="theme-plan-option-content">
								<Checkbox
									checked={hasReadTC}
									style={{ paddingLeft: 0 }}
									onChange={handleAgreedTCCheckboxChange}
								/>
								<p className="theme-plan-checkbox-label">
									<strong>
										I have read the{" "}
										<span
											className="veb-plan-disclaimer"
											style={{ color: theme.primary_color }}
											onClick={handleOpenDisclaimerDialogClick}
										>
											Disclaimer
										</span>
									</strong>
								</p>
							</div>
						</div>
						<div className="theme-plan-inner-section-margin-2" />
						{/* <Grid container>
						<Grid item xl={4} lg={4} md={4} sm={4} xs={10} columnSpacing={2}>
							<div className="details-form-row">
								<div className="details-form-label required">Writing Number</div>
								<Grid container>
									<Grid item xl={9}>
										<CustomInput value={writingNumber} onChange={handleWritingNumberChange} />
									</Grid>
									{showWritingNumberValidateButton ? (
										<Grid item xl={3}>
											<div className="writing-number-validate-container">
												<Button
													style={{
														backgroundColor: theme.button.background_color,
														color: theme.button.color,
														opacity: 0.8
													}}
												>
													Validate
												</Button>
											</div>
										</Grid>
									) : null}
								</Grid>
							</div>
						</Grid>
					</Grid> */}
						<div className="theme-plan-inner-section-margin-2" />
						<LazyPlanActions
							waiveButtonCallback={handleWaiveButtonClick}
							activateButtonCallback={handleActivateButtonCallback}
						/>
					</Paper>
				</div>
			</div>
			{isDependentExistsModelOpen && (
				<ExistsDependentModelVEB
					onClose={() => setIsDependentExistsModelOpen(false)}
					dependentData={existsDependentData}
				/>
			)}
		</>
	);
};

export default KemperHospitalIndemnityForm;
